class CompareStickyBar extends HTMLElement {
    constructor() {
      super();
      this.container = null;
      this.products = [];
      this.isHidden = false;
    }
  
    async connectedCallback() {
      this.clearStickyBar = this.querySelector(".clear_all");
      this.stkcyCounterList = this.querySelector(".compare-sticky--counter-list");
      this.stickyCounterLength = this.querySelector(".compare-sticky--counter-length");
      this.compareButton = this.querySelector(".button--compare");
      this.container = this.querySelector("#compare-sticky-products");
      
      if (!this.clearStickyBar || !this.stkcyCounterList || !this.stickyCounterLength) {
          console.error('Required elements not found in CompareStickyBar');
          return;
      }
      
      this.products = Utils.getSelectedProduct();
      this.stickyCounterLength.innerText = Utils.maxProductsInCompare;
      this.clearStickyBar.addEventListener("click", this.handleClear.bind(this));
  
      if (this.products.length > 0) {
        for (const p of this.products) {
          await this.render(p);
        }
        this.addPlaceholders(this.products.length);
      } else {
        this.addPlaceholders(0);
      }
      this.updateCounters(this.products.length);
      this.compareButtonStatus(this.products.length);
      
      window.addEventListener('compare-products-changed', this.onProductsChanged.bind(this));
      window.addEventListener('scroll', this.handleScroll.bind(this), { passive: true });
      window.addEventListener('resize', this.handleResize.bind(this), { passive: true });
      
      this.showBar();
    }
  
    disconnectedCallback() {
      window.removeEventListener('compare-products-changed', this.onProductsChanged);
      window.removeEventListener('scroll', this.handleScroll);
      window.removeEventListener('resize', this.handleResize);
      this.clearStickyBar?.removeEventListener("click", this.handleClear);
    }
  
    handleScroll() {
      const currentScrollY = window.scrollY;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      const distanceFromBottom = documentHeight - (currentScrollY + windowHeight);
      const stickyBarHeight = this.offsetHeight || 80;
      
      if (distanceFromBottom <= stickyBarHeight + 10) {
        this.hideBar();
      } else {
        this.showBar();
      }
    }
  
    handleResize() {
      this.handleScroll();
    }
  
    hideBar() {
      if (!this.isHidden) {
        this.isHidden = true;
        this.classList.add('sticky-hidden');
      }
    }
  
    showBar() {
      if (this.isHidden) {
        this.isHidden = false;
        this.classList.remove('sticky-hidden');
      }
    }
  
    onProductsChanged(event) {
      const newProducts = event.detail;
      const addedProducts = newProducts.filter(
        p => !this.products.some(existing => existing.id === p.id)
      );
      const removedProducts = this.products.filter(
        p => !newProducts.some(np => np.id === p.id)
      );
      
      addedProducts.forEach(p => this.render(p));
      removedProducts.forEach(p => {
        const el = this.container.querySelector(`[data-product-id="${p.id}"]`);
        if (el) {
          el.remove();
          this.addPlaceholders(newProducts.length);
        }
      });
      
      this.products = newProducts;
      this.updateCounters(this.products.length);
      this.compareButtonStatus(this.products.length);
    }
  
    async fetchProduct(handle) {
        try {
            if (!handle) {
                throw new Error('No product handle provided');
            }
            const url = `${handle}?sections=product-compare-sticky`;
            const res = await fetch(url);
            if (!res.ok) {
                throw new Error(`HTTP error! status: ${res.status}`);
            }
            const data = await res.json();
            if (!data["product-compare-sticky"]) {
                throw new Error('Product section not found in response');
            }
            return this.getSectionInnerHTML(data["product-compare-sticky"], ".shopify-section");
        } catch (err) {
            console.error("fetchProduct error:", err);
            return null;
        }
    }
  
    getSectionInnerHTML(html, selector) {
      return new DOMParser().parseFromString(html, "text/html").querySelector(selector).innerHTML;
    }
  
    async render(newProduct = null) {
      if (!this.container) return;
      if (newProduct) {
        const html = await this.fetchProduct(newProduct.url || newProduct);
        if (!Utils.isProductInList(newProduct.id)) {
          return;
        }
        if (!html) {
          console.warn('Failed to fetch product HTML');
          return;
        }
        const firstPlaceholder = this.container.querySelector(".compare-sticky--item-placeholder");
        if (firstPlaceholder) {
          firstPlaceholder.insertAdjacentHTML("beforebegin", html);
          firstPlaceholder.remove();
        } else {
          this.container.insertAdjacentHTML("beforeend", html);
        }
        const newItem = this.container.querySelector(`[data-product-id="${newProduct.id}"]`);
        const removeBtn = newItem?.querySelector(".sticky--item-remove");
        if (removeBtn) {
          const handleRemove = () => Utils.removeFromProductList(newProduct.id);
          removeBtn.addEventListener("click", handleRemove);
          removeBtn._removeHandler = handleRemove;
        }
      }
    }
  
    handleClear(){
      Utils.clearList();
    }
  
    updateCounters(count) {
      this.stkcyCounterList.innerText = count;
    }
  
    compareButtonStatus(count) {
      this.compareButton.disabled = !(count > 1);
    }
  
    addPlaceholders(count) {
      this.container.querySelectorAll(".compare-sticky--item-placeholder").forEach(el => el.remove());
      const placeholderCount = Utils.isMaxProductCounter() - count;
      for (let i = 0; i < placeholderCount; i++) {
        const placeholderItem = document.createElement("div");
        placeholderItem.classList.add(
          "compare-sticky--item",
          "compare-sticky--item-placeholder"
        );
        this.container.appendChild(placeholderItem);
      }
    }
  }
  customElements.define("compare-sticky-bar", CompareStickyBar);